module.exports = __webpack_public_path__ + "media/images/items/anim-5-0e86236d65f699e63c1def7bde7bdc08.webp";